var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { BwElement } from './base/bw-element.js';
let BwSegmentedControl = class BwSegmentedControl extends BwElement {
    constructor() {
        super(...arguments);
        this.size = 'sm';
        this.value = '';
        this.segments = [];
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute('role'))
            this.setAttribute('role', 'radiogroup');
    }
    render() {
        return html `
      ${this.segments.map((seg) => html `
        <button
          type="button"
          class="bw-seg-segment"
          data-value=${seg.value}
          data-tone=${seg.tone ?? 'default'}
          role="radio"
          aria-checked=${seg.value === this.value ? 'true' : 'false'}
          tabindex=${seg.value === this.value ? 0 : -1}
          ?disabled=${seg.disabled ?? false}
          @click=${() => this._onSelect(seg)}
          @keydown=${(e) => this._onKeyDown(e)}
        >${seg.label}</button>
      `)}
    `;
    }
    _onSelect(seg) {
        if (seg.disabled)
            return;
        if (this.value === seg.value)
            return;
        this.value = seg.value;
        this.dispatchEvent(new CustomEvent('bw-segmented-change', {
            detail: { value: seg.value },
            bubbles: true,
            composed: true,
        }));
    }
    _onKeyDown(e) {
        const key = e.key;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' &&
            key !== 'ArrowDown' && key !== 'ArrowUp' &&
            key !== 'Home' && key !== 'End') {
            return;
        }
        e.preventDefault();
        const segs = this.segments;
        const enabledIdxs = segs.map((s, i) => s.disabled ? -1 : i).filter(i => i >= 0);
        if (enabledIdxs.length === 0)
            return;
        const currentIdx = segs.findIndex(s => s.value === this.value);
        const currentEnabledPos = enabledIdxs.indexOf(currentIdx);
        let nextEnabledPos;
        if (key === 'ArrowRight' || key === 'ArrowDown') {
            nextEnabledPos = currentEnabledPos < 0 ? 0 : (currentEnabledPos + 1) % enabledIdxs.length;
        }
        else if (key === 'ArrowLeft' || key === 'ArrowUp') {
            nextEnabledPos = currentEnabledPos < 0
                ? enabledIdxs.length - 1
                : (currentEnabledPos - 1 + enabledIdxs.length) % enabledIdxs.length;
        }
        else if (key === 'Home') {
            nextEnabledPos = 0;
        }
        else {
            nextEnabledPos = enabledIdxs.length - 1;
        }
        const nextSeg = segs[enabledIdxs[nextEnabledPos]];
        this._onSelect(nextSeg);
        queueMicrotask(async () => {
            await this.updateComplete;
            const btn = this.querySelector(`.bw-seg-segment[data-value="${nextSeg.value}"]`);
            btn?.focus();
        });
    }
};
__decorate([
    property({ type: String, reflect: true })
], BwSegmentedControl.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwSegmentedControl.prototype, "value", void 0);
__decorate([
    property({ attribute: false })
], BwSegmentedControl.prototype, "segments", void 0);
BwSegmentedControl = __decorate([
    customElement('bw-segmented-control')
], BwSegmentedControl);
export { BwSegmentedControl };
//# sourceMappingURL=bw-segmented-control.js.map